import { AfterViewInit, Directive, ElementRef, Input, NgZone, OnChanges, OnDestroy } from '@angular/core';

/** Fade content without moving the coach or leaving invisible controls focusable. */
@Directive({ selector: '[tourReveal]', standalone: true })
export class TourRevealDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input() tourReveal: string | number = '';
  @Input() revealDelay = 0;
  @Input() revealDuration = 550;
  private ready = false;
  private animation?: Animation;
  private motion?: MediaQueryList;

  constructor(private element: ElementRef<HTMLElement>, private zone: NgZone) {}

  ngAfterViewInit(): void {
    this.ready = true;
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.motion.addEventListener('change', this.motionChanged);
    this.reveal();
  }

  ngOnChanges(): void { if (this.ready) this.reveal(); }

  private readonly motionChanged = (): void => {
    if (this.motion?.matches) this.animation?.cancel();
  };

  private reveal(): void {
    this.animation?.cancel();
    const element = this.element.nativeElement;
    if (this.motion?.matches || !element.animate || element.contains(document.activeElement)) return;
    this.zone.runOutsideAngular(() => {
      const animation = element.animate([
        // Visibility also removes delayed buttons from keyboard navigation.
        { opacity: 0, visibility: 'hidden', offset: 0 },
        { opacity: 0, visibility: 'visible', offset: 0.001 },
        { opacity: 1, visibility: 'visible', offset: 1 }
      ], { delay: this.revealDelay, duration: this.revealDuration, easing: 'cubic-bezier(.22, .61, .36, 1)', fill: 'both' });
      this.animation = animation;
      // Restore ordinary styles after the fade; no persistent hidden state or timers.
      animation.onfinish = () => animation.cancel();
    });
  }

  ngOnDestroy(): void {
    this.animation?.cancel();
    this.motion?.removeEventListener('change', this.motionChanged);
  }
}
